module.exports = __webpack_public_path__ + "static/media/default.1221bc0b.png";